/* eslint-disable eqeqeq */
/* eslint-disable default-case */
import React, { useEffect, useState } from "react";
import {
  Stack,
  TextField,
  FormControl,
  Button,
  Backdrop,
  CircularProgress,
  Portal,
} from "@mui/material";
import { IoCopy } from "react-icons/io5";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import dayjs from "dayjs";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import "dayjs/locale/en-gb";
import { useDispatch } from "react-redux";
import { AiOutlineClose } from "react-icons/ai";
import {
  getInterviewSchedulePosibility,
  getJobLocationFormJobId,
  scheduleInterview,
} from "../../../../services/interviewServices";
import {
  copyToClipboard,
  dateFormate,
  dMMMYYYY_formate,
  numbersOnlyTest,
} from "../../../../utility";
import { MyModal } from "../../../../components/Common/Model/MyModal";
import ModalContainer from "../../../../components/Common/Model/ModalContainer";
export default function ScheduleInterview({
  interviewDate,
  candidateId,
  relationName,
  relationType,
  relationNumber,
  showPopup,
  // onClose,
}) {
  // console.log(showCandidateName);
  const [formData, setFormData] = useState({
    candidateId: candidateId,
    jobId: "",
    candidatePercentage: "",
    EmeregncyContactNumber: relationNumber,
    RelationshipName: relationName,
    Relationship: relationType,
    date: interviewDate || null,
    showPopup: showPopup,
    showWhatsApp: false,
    message: "",
    message1: "",
    whatsappnumber: "",
    interviewType: "", // 'online' or 'offline'
    currentlyWorkingStatus: "",
    jobCityMatch: "",
    showTypeSelection: false,
  });

  const [errors, setErrors] = useState({
    candidateId: "",
    candidatePercentage: "",
    Relationship: "",
    RelationshipName: "",
    EmeregncyContactNumber: "",
    jobId: "",
    date: "",
  });
  const [alertschedule, setAlertSchedule] = useState({
    multipleSchedule: false,
    joinedStatus: false,
    noOfVacancy: false,
    message: "",
  });
  const [showLoader, setShowLoader] = useState(false);
  const [enableSubmit, setEnableSubmit] = useState(true);
  const [jobCity, setJobCity] = useState("");
  const showCandidateId = candidateId != null;
  const Dispatch = useDispatch();
  const [warningShow, setWarningShow] = useState(false);
  const [showError, setShowError] = useState({
    job_category_match: [],
    preferredLocation: [],
    experience_match: [],
  });
  const validateForm = () => {
    const newErrors = {};
    if (!formData.candidateId) {
      newErrors.candidateId = "Candidate ID is required";
    }
    if (!formData.jobId) {
      newErrors.jobId = "Job ID is required";
    }
    if (!formData.date) {
      newErrors.date = "Date is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  useEffect(() => {
    console.log(formData);
  }, [formData]);

  function handleFieldChange(field, value) {
    console.log(numbersOnlyTest(value));
    switch (field) {
      case "candidateId":
        if (numbersOnlyTest(value)) {
          setFormData((prev) => ({ ...prev, [field]: value }));
          // setErrors((prev) => ({ ...prev, date: "" }));
        }
        break;
      case "jobId":
        if (numbersOnlyTest(value)) {
          setFormData((prev) => ({ ...prev, [field]: value }));
          setErrors((prev) => ({ ...prev, jobId: "" }));
        } else {
          setErrors((prev) => ({
            ...prev,
            jobId: "Please enter valid job Id",
          }));
        }
        break;
      case "date":
        const formattedDate = dateFormate(value.$d);
        setFormData((prev) => ({ ...prev, [field]: formattedDate }));

        setErrors((prev) => ({ ...prev, date: "" }));
        break;

      case "candidatePercentage":
        setFormData((prev) => ({ ...prev, [field]: value }));

        setErrors((prev) => ({ ...prev, candidatePercentage: "" }));
        break;
      case "EmeregncyContactNumber":
        setFormData((prev) => ({ ...prev, [field]: value }));

        setErrors((prev) => ({ ...prev, EmeregncyContactNumber: "" }));
        break;
      case "Relationship":
        setFormData((prev) => ({ ...prev, [field]: value }));

        setErrors((prev) => ({ ...prev, Relationship: "" }));
        break;
      case "RelationshipName":
        setFormData((prev) => ({ ...prev, [field]: value }));

        setErrors((prev) => ({ ...prev, RelationshipName: "" }));
        break;

      case "whatsappnumber":
        setFormData((prev) => ({ ...prev, [field]: value }));

        setErrors((prev) => ({ ...prev, whatsappnumber: "" }));
        break;
    }
  }

  // const handleCopy = () => {
  //   let formattedMsg = decodeURIComponent(formData.message);
  //   navigator.clipboard
  //     .writeText(formattedMsg)
  //     .then(() => {
  //       alert("Text copied to clipboard");
  //     })
  //     .catch((err) => {
  //       console.error("Failed to copy text: ", err);
  //     });
  // };

  // const handleCopy1 = () => {
  //   let formattedMsg = decodeURIComponent(formData.message1);
  //   navigator.clipboard
  //     .writeText(formattedMsg)
  //     .then(() => {
  //       alert("Text copied to clipboard");
  //     })
  //     .catch((err) => {
  //       console.error("Failed to copy text: ", err);
  //     });
  // };

  const handleCopy = () => {
    if (!formData.message) return;
    const formattedMsg = decodeURIComponent(formData.message);
    copyToClipboard(formattedMsg);
  };

  const handleCopy1 = () => {
    if (!formData.message1) return;
    const formattedMsg = decodeURIComponent(formData.message1);
    copyToClipboard(formattedMsg);
  };
  const handleSubmit = (event) => {
    event.preventDefault();
    if (validateForm()) {
      // Submit the form or handle the action
      console.log("Form submitted:", formData);
      setFormData((prev) => ({ ...prev, loading: true }));

      scheduleInterview(formData)
        .then((res) => {
          if (
            res.message ===
            "Interview already scheduled multiple times for this candidate and job"
          ) {
            // alert("Interview already scheduled");
            setAlertSchedule((prev) => ({
              ...prev,
              multipleSchedule: true,
            }));
            setFormData({ ...formData, loading: false });
            return;
          } else if (res.code === 400) {
            setAlertSchedule((prev) => ({
              ...prev,
              joinedStatus: true,
              message: res.message, // 👈 dynamic message from backend
            }));

            setFormData({ ...formData, loading: false });
            return;
          } else if (res.message === "This job ID no.of.vacancy is 0.") {
            // alert("Number of vacancy is 0");
            setAlertSchedule((prev) => ({
              ...prev,
              noOfVacancy: true,
            }));
            return;
          } else {
            const message = `
Hi *${res.candidateName}*, you have an interview scheduled with *${
              res.company_name
            }*, *${res.area} - ${res.city}* at *9:30 AM*, *${dMMMYYYY_formate(
              res.interview_date,
            )}*.

Call *${res.contact_person_name}* at *${
              res.contact_person_number
            }* to confirm the interview before you leave. Do not forget to carry the necessary documents while going to the interview.

All documents with two sets of Xerox copy
*Bio-data, All Education Certificate, Aadhaar Card, Ration Card, 2 Passport Size Photo, Bank Passbook*

*Benefits* : ${res.benefits}

*Company Location Link* : ${res.JobLocationUrl}

Thank you
*Taizo Team*
`;

            const message1 = `
Hi *${res.candidateName}*,

We’re excited to confirm your interview with *${
              res.company_name
            }* on *${dMMMYYYY_formate(res.interview_date)} at 9:30 AM*.

The link will be shared 2 hours before the interview. Please be in a quiet place with good internet.

Make sure to have the interview documents ready as digital copies.

If you have any questions, feel free to message me here or call *${
              res.contact_person_number
            }*.

Looking forward to speaking with you!

`;

            const urlEncodedMessage = encodeURIComponent(message);
            const urlEncodedMessage1 = encodeURIComponent(message1);

            setFormData({ ...formData, loading: false });
            setFormData({ ...formData, completed: true });

            // Dispatch(CandidatePipelineActions.setRefreshCount());
            setTimeout(() => {
              setFormData({
                jobId: "",
                candidateId: candidateId,
                jobRole: "",
                date: "",
                Relationship: "",
                candidatePercentage: "",
                EmeregncyContactNumber: relationNumber,
                RelationshipName: relationName,
                showPopup: true,
                completed: false,
                failed: false,
                loading: false,
                showTypeSelection: true,
                showWhatsApp: true,
                message: urlEncodedMessage,
                message1: urlEncodedMessage1,
                whatsappnumber: res.candidateWhatsappNUmber,
              });
            }, [1000]);

            // Dispatch(CandidatePipelineActions.setRefreshCount());
          }
        })
        .catch(() => {
          // Handle other errors
          alert("Something went wrong, Please try again later.");
          setFormData({ ...formData, loading: false });
        });
    }
  };

  useEffect(() => {
    const { candidateId, jobId, currentlyWorkingStatus, jobCityMatch, date } =
      formData;

    if (candidateId && jobId && currentlyWorkingStatus && jobCityMatch) {
      const payload = {
        candidateId,
        jobId,
        workingStatus:
          currentlyWorkingStatus === "Yes"
            ? true
            : currentlyWorkingStatus === "No"
              ? false
              : "",
        matchCity:
          jobCityMatch === "Yes" ? true : jobCityMatch === "No" ? false : "",
      };

      setShowLoader(true);

      getInterviewSchedulePosibility(payload)
        .then((res) => {
          setFormData((prev) => ({
            ...prev,
            candidatePercentage: res.matchPercentage,
          }));

          const result = res.result;

          // Initialize error state
          const newErrorState = {
            job_category_match: [],
            preferredLocation: [],
            experience_match: [],
          };

          // Check and set errors per field
          if (result.job_category_match?.status === "error") {
            newErrorState.job_category_match.push(
              result.job_category_match.message,
            );
          }
          if (result.location_match?.status === "error") {
            newErrorState.preferredLocation.push(result.location_match.message);
          }
          if (result.experience_match?.status === "error") {
            newErrorState.experience_match.push(
              result.experience_match.message,
            );
          }

          const hasErrors =
            newErrorState.job_category_match.length > 0 ||
            newErrorState.preferredLocation.length > 0 ||
            newErrorState.experience_match.length > 0;

          if (hasErrors) {
            setWarningShow(true);
            setShowError(newErrorState);
            setEnableSubmit(true);
          } else {
            // Clear errors if no mismatch
            setShowError({
              job_category_match: [],
              preferredLocation: [],
              experience_match: [],
            });

            setEnableSubmit(date === "" ? true : false);
          }
        })
        .catch((err) => {
          console.error("Error fetching possibility", err);
          // Optionally set a global error message if needed
        })
        .finally(() => {
          setShowLoader(false);
        });
    }
  }, [
    formData.candidateId,
    // formData.jobId,
    formData.currentlyWorkingStatus,
    formData.jobCityMatch,
    formData.date,
  ]);

  useEffect(() => {
    // Reset form data when jobId changes
    setFormData((prev) => ({
      ...prev,
      currentlyWorkingStatus: "",
      jobCityMatch: "",
      candidatePercentage: "",
      date: "",
    }));

    setEnableSubmit(true);

    // Debounce API call
    const handler = setTimeout(() => {
      if (formData.jobId) {
        getJobLocationFormJobId(formData.jobId).then((data) => {
          const location = data.results.result;
          const jobCity = location.map((el) => el.job_city);
          setJobCity(jobCity);
        });
      }
    }, 500); // 500ms delay

    // Cleanup function clears timeout if jobId changes again before delay ends
    return () => {
      clearTimeout(handler);
    };
  }, [formData.jobId]);
  return (
    <>
      {" "}
      <div>
        <div>
          <div
            sx={{ mx: "5px" }}
            onClick={(event) =>
              setFormData({
                ...formData,
                showPopup: true,
              })
            }
          >
            Schedule&nbsp;Interview
          </div>
        </div>
        {formData.showPopup && (
          <>
            <MyModal>
              <ModalContainer>
                <>
                  <div className="mb-2 d-flex align-items-center justify-content-between">
                    <b className="text-center ">Schedule&nbsp;Interview</b>
                    <button
                      className="btn btn-danger"
                      onClick={(event) => {
                        setEnableSubmit(true);
                        setFormData({
                          ...formData,
                          candidateId: candidateId,
                          jobId: "",
                          jobRole: "",
                          date: "",
                          Relationship: relationType,
                          candidatePercentage: "",
                          EmeregncyContactNumber: relationNumber,
                          RelationshipName: relationName,
                          showPopup: false,
                          showTypeSelection: "",
                          message: "",
                          message1: "",
                          currentlyWorkingStatus: "",
                          jobCityMatch: "",
                        });
                        // onClose();
                        // Dispatch(CandidatePipelineActions.setRefreshCount());
                      }}
                    >
                      <AiOutlineClose />
                    </button>
                  </div>

                  <form
                    style={{
                      overflowY: "auto",
                      maxHeight: "75vh",
                      // minWidth: "35vw",
                    }}
                    // className="py-4"
                    onSubmit={handleSubmit}
                  >
                    <Stack spacing={2}>
                      {!showCandidateId && (
                        <TextField
                          id="candidateId"
                          label="Candidate ID"
                          name="candidateId"
                          value={formData.candidateId}
                          onChange={(event, value) =>
                            handleFieldChange("candidateId", event.target.value)
                          }
                          error={Boolean(errors.candidateId)}
                          helperText={errors.candidateId}
                          fullWidth
                          required
                          inputProps={{ maxLength: 10 }}
                        />
                      )}
                      <TextField
                        id="jobId"
                        label="Job ID"
                        name="jobId"
                        value={formData.jobId}
                        onChange={(event) =>
                          handleFieldChange("jobId", event.target.value)
                        }
                        error={Boolean(errors.jobId)}
                        helperText={errors.jobId}
                        fullWidth
                        required
                        className="mt-2"
                        inputProps={{ maxLength: 6 }}
                      />

                      {/* <span className="row"> */}
                      <div className="col-sm-6 d-flex flex-column gap-3  ">
                        <label className="fw-bold">Currently working</label>
                        <div className="d-flex gap-3">
                          {["Yes", "No"].map((type) => (
                            <label
                              key={type}
                              style={{
                                padding: "8px 20px",
                                border: "1.5px solid",
                                borderColor:
                                  formData.currentlyWorkingStatus === type
                                    ? "#169c50"
                                    : "gray",
                                borderRadius: "8px",
                                cursor: "pointer",
                                color:
                                  formData.currentlyWorkingStatus === type
                                    ? "#169c50"
                                    : "gray",
                                fontWeight: 500,
                                backgroundColor:
                                  formData.currentlyWorkingStatus === type
                                    ? "#e6fff1"
                                    : "transparent",
                                transition: "all 0.3s ease",
                              }}
                              onMouseEnter={(e) => {
                                if (formData.currentlyWorkingStatus !== type) {
                                  e.target.style.borderColor = "#169c50";
                                  e.target.style.color = "#169c50";
                                }
                              }}
                              onMouseLeave={(e) => {
                                if (formData.currentlyWorkingStatus !== type) {
                                  e.target.style.borderColor = "gray";
                                  e.target.style.color = "gray";
                                }
                              }}
                            >
                              <input
                                type="radio"
                                name="currentlyWorkingStatus"
                                value={type}
                                checked={
                                  formData.currentlyWorkingStatus === type
                                }
                                onChange={(e) =>
                                  setFormData({
                                    ...formData,
                                    currentlyWorkingStatus: e.target.value,
                                  })
                                }
                                style={{ display: "none" }}
                              />
                              {type.charAt(0).toUpperCase() + type.slice(1)}
                            </label>
                          ))}
                        </div>
                      </div>
                      <div className="d-flex flex-column gap-3  ">
                        <label className="fw-bold">
                          Does the {jobCity != "" ? jobCity : "job city"} match
                          the candidate's current location?
                        </label>
                        <div className="d-flex gap-3">
                          {["Yes", "No"].map((type) => (
                            <label
                              key={type}
                              style={{
                                padding: "8px 20px",
                                border: "1.5px solid",
                                borderColor:
                                  formData.jobCityMatch === type
                                    ? "#169c50"
                                    : "gray",
                                borderRadius: "8px",
                                cursor: "pointer",
                                color:
                                  formData.jobCityMatch === type
                                    ? "#169c50"
                                    : "gray",
                                fontWeight: 500,
                                backgroundColor:
                                  formData.jobCityMatch === type
                                    ? "#e6fff1"
                                    : "transparent",
                                transition: "all 0.3s ease",
                              }}
                              onMouseEnter={(e) => {
                                if (formData.jobCityMatch !== type) {
                                  e.target.style.borderColor = "#169c50";
                                  e.target.style.color = "#169c50";
                                }
                              }}
                              onMouseLeave={(e) => {
                                if (formData.jobCityMatch !== type) {
                                  e.target.style.borderColor = "gray";
                                  e.target.style.color = "gray";
                                }
                              }}
                            >
                              <input
                                type="radio"
                                name="jobCityMatch"
                                value={type}
                                checked={formData.jobCityMatch === type}
                                onChange={(e) =>
                                  setFormData({
                                    ...formData,
                                    jobCityMatch: e.target.value,
                                  })
                                }
                                style={{ display: "none" }}
                              />
                              {type.charAt(0).toUpperCase() + type.slice(1)}
                            </label>
                          ))}
                        </div>
                      </div>
                      <FormControl disabled>
                        <InputLabel id="demo-simple-select-helper-label">
                          Interview Possibility
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-helper-label"
                          id="demo-simple-select-helper"
                          // value={age}
                          name="candidatePercentage"
                          label="Interview Possibility"
                          // onChange={handleChange}
                          value={formData.candidatePercentage}
                          onChange={(event) =>
                            handleFieldChange(
                              "candidatePercentage",
                              event.target.value,
                            )
                          }
                          required
                          slotProps={{
                            textField: {
                              helperText: errors.candidatePercentage,
                              error: Boolean(errors.candidatePercentage),
                            },
                          }}
                          defaultValue={50}
                        >
                          {/* <MenuItem value=""></MenuItem> */}
                          <MenuItem value={0}>0%</MenuItem>
                          <MenuItem value={50}>50%</MenuItem>
                          <MenuItem value={100}>100%</MenuItem>
                        </Select>
                        {/* <FormHelperText>With label + helper text</FormHelperText> */}
                      </FormControl>
                      {/* </span> */}
                      <FormControl>
                        <LocalizationProvider
                          adapterLocale="en-gb"
                          dateAdapter={AdapterDayjs}
                        >
                          <DatePicker
                            label="Date"
                            value={dayjs(formData.date)}
                            name="date"
                            minDate={dayjs()} // Minimum date is today
                            // shouldDisableDate={(date) => {
                            //   // Disable dates outside the range of today and the next 2 days
                            //   const today = dayjs().startOf("day");
                            //   const twoDaysFromToday = today.add(2, "day");
                            //   return (
                            //     date.isBefore(today, "day") ||
                            //     date.isAfter(twoDaysFromToday, "day")
                            //   );
                            // }}
                            onChange={(value) => {
                              handleFieldChange("date", value);
                              console.log(
                                "Selected Date:",
                                dateFormate(value.$d),
                              );
                            }}
                            fullWidth
                            required
                            inputFormat="DD/MM/YYYY" // Specify the date format
                            disableMaskedInput // Disable the ability to type the date manually
                            slotProps={{
                              textField: {
                                helperText: errors.date,
                                error: Boolean(errors.date),
                                inputProps: {
                                  readOnly: true, // Disallow typing in the input field
                                },
                              },
                            }}
                          />
                        </LocalizationProvider>
                      </FormControl>

                      {formData.showTypeSelection && (
                        <div className="d-flex flex-column gap-3 mt-4">
                          <label className="fw-bold">
                            Select Interview Type:
                          </label>
                          <div className="d-flex gap-3">
                            {["offline", "online"].map((type) => (
                              <label
                                key={type}
                                style={{
                                  padding: "8px 20px",
                                  border: "1.5px solid",
                                  borderColor:
                                    formData.interviewType === type
                                      ? "#169c50"
                                      : "gray",
                                  borderRadius: "8px",
                                  cursor: "pointer",
                                  color:
                                    formData.interviewType === type
                                      ? "#169c50"
                                      : "gray",
                                  fontWeight: 500,
                                  backgroundColor:
                                    formData.interviewType === type
                                      ? "#e6fff1"
                                      : "transparent",
                                  transition: "all 0.3s ease",
                                }}
                                onMouseEnter={(e) => {
                                  if (formData.interviewType !== type) {
                                    e.target.style.borderColor = "#169c50";
                                    e.target.style.color = "#169c50";
                                  }
                                }}
                                onMouseLeave={(e) => {
                                  if (formData.interviewType !== type) {
                                    e.target.style.borderColor = "gray";
                                    e.target.style.color = "gray";
                                  }
                                }}
                              >
                                <input
                                  type="radio"
                                  name="interviewType"
                                  value={type}
                                  checked={formData.interviewType === type}
                                  onChange={(e) =>
                                    setFormData({
                                      ...formData,
                                      interviewType: e.target.value,
                                    })
                                  }
                                  style={{ display: "none" }}
                                />
                                {type.charAt(0).toUpperCase() + type.slice(1)}
                              </label>
                            ))}
                          </div>
                        </div>
                      )}

                      {/* {formData.message != "" && ( */}
                      {formData.interviewType === "offline" &&
                        formData.message && (
                          <div className="d-flex flex-row gap-3">
                            <TextField
                              id="outlined-basic"
                              label="Whatsapp Number"
                              value={formData.whatsappnumber}
                              variant="outlined"
                              required
                              onChange={(event) =>
                                handleFieldChange(
                                  "whatsappnumber",
                                  event.target.value,
                                )
                              }
                            />
                            <a
                              href={`https://wa.me/+${formData.whatsappnumber}/?text=${formData.message}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="text-white"
                              style={{ textDecoration: "none" }}
                            >
                              <Button
                                color="primary"
                                variant="contained"
                                size="small"
                                onClick={(event) => {
                                  // setFormData({
                                  //   ...formData,
                                  //   showPopup: true,
                                  //   message: "",
                                  // });
                                  // Dispatch(
                                  //   CandidatePipelineActions.setRefreshCount()
                                  // );
                                }}
                              >
                                {" "}
                                Interview Alert
                              </Button>{" "}
                            </a>
                            <IoCopy
                              onClick={handleCopy}
                              style={{ cursor: "pointer" }}
                            />
                          </div>
                        )}

                      {/* {formData.message1 != "" && ( */}
                      {formData.interviewType === "online" &&
                        formData.message1 && (
                          <div className="d-flex flex-row gap-3">
                            <TextField
                              id="outlined-basic"
                              label="Whatsapp Number"
                              value={formData.whatsappnumber}
                              variant="outlined"
                              required
                              onChange={(event) =>
                                handleFieldChange(
                                  "whatsappnumber",
                                  event.target.value,
                                )
                              }
                            />
                            <a
                              href={`https://wa.me/+${formData.whatsappnumber}/?text=${formData.message1}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="text-white"
                              style={{ textDecoration: "none" }}
                            >
                              <Button
                                color="primary"
                                variant="contained"
                                size="small"
                                onClick={(event) => {
                                  // setFormData({
                                  //   ...formData,
                                  //   showPopup: true,
                                  //   message1: "",
                                  // });
                                  // Dispatch(
                                  //   CandidatePipelineActions.setRefreshCount()
                                  // );
                                }}
                              >
                                {" "}
                                Interview Alert
                              </Button>{" "}
                            </a>
                            <IoCopy
                              onClick={handleCopy1}
                              style={{ cursor: "pointer" }}
                            />
                          </div>
                        )}

                      <div className="d-flex flex-row gap-5 justify-content-end">
                        <button
                          disabled={
                            enableSubmit ||
                            formData.loading ||
                            formData.showTypeSelection
                          }
                          type="submit"
                          className="btn btn-success"
                          // sx={{ minWidth: "150px" }}
                        >
                          {!formData.loading && !formData.completed && "Submit"}

                          {
                            formData.loading && (
                              <div className="spinner-border spinner-border-sm text-light"></div>
                            ) // Add spinner here
                          }

                          {formData.completed && "Submitted"}
                        </button>
                      </div>
                    </Stack>
                  </form>
                </>
              </ModalContainer>
            </MyModal>
            {alertschedule.multipleSchedule && (
              <MyModal>
                <ModalContainer>
                  <>
                    <div className="p-1">
                      <div>
                        <p>
                          {`This candidate is already scheduled for an
                          interview with this company`}
                        </p>
                      </div>
                      <div className="d-flex justify-content-end">
                        <div
                          className="btn btn-danger px-4 "
                          onClick={() =>
                            setAlertSchedule((prev) => ({
                              ...prev,
                              multipleSchedule: false,
                            }))
                          }
                        >
                          Ok
                        </div>
                        {/* <HiHandThumbUp /> */}
                      </div>
                    </div>
                  </>
                </ModalContainer>
              </MyModal>
            )}
            {alertschedule.joinedStatus && (
              <MyModal>
                <ModalContainer>
                  <div className="p-1">
                    <div>
                      <p>{alertschedule.message}</p>
                    </div>

                    <div className="d-flex justify-content-end">
                      <div
                        className="btn btn-danger px-4"
                        onClick={() =>
                          setAlertSchedule((prev) => ({
                            ...prev,
                            joinedStatus: false,
                            message: "", // 👈 reset
                          }))
                        }
                      >
                        Ok
                      </div>
                    </div>
                  </div>
                </ModalContainer>
              </MyModal>
            )}
            {alertschedule.noOfVacancy && (
              <MyModal>
                <ModalContainer>
                  <>
                    <div className="p-1">
                      <div>
                        <p>{`This job id number of vacancy is 0`}</p>
                      </div>
                      <div className="d-flex justify-content-end">
                        <div
                          className="btn btn-danger px-4 "
                          onClick={() => {
                            setAlertSchedule((prev) => ({
                              ...prev,
                              noOfVacancy: false,
                            }));
                            setFormData({ ...formData, loading: false });
                          }}
                        >
                          Ok
                        </div>
                        {/* <HiHandThumbUp /> */}
                      </div>
                    </div>
                  </>
                </ModalContainer>
              </MyModal>
            )}
          </>
        )}
        <Portal>
          <Backdrop
            sx={{
              color: "#fff",
              zIndex: 20000,
            }}
            open={showLoader}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
        </Portal>

        {warningShow && (
          <MyModal>
            <ModalContainer>
              <>
                {(showError.job_category_match.length > 0 ||
                  showError.preferredLocation.length > 0 ||
                  showError.experience_match.length > 0) && (
                  <div className="alert alert-warning">
                    <strong>Warning:</strong>

                    <ul className="mt-2">
                      {showError.job_category_match.map((msg, index) => (
                        <li key={`category-${index}`}>{msg}</li>
                      ))}
                      <br />
                      {showError.preferredLocation.map((msg, index) => (
                        <li key={`location-${index}`}>{msg}</li>
                      ))}
                      <br />
                      {showError.experience_match.map((msg, index) => (
                        <li key={`experience-${index}`}>{msg}</li>
                      ))}
                    </ul>
                  </div>
                )}
                <div className="d-flex align-items-center justify-content-end ">
                  <button
                    className="btn btn-danger"
                    onClick={() => {
                      setWarningShow(false);
                    }}
                  >
                    OK
                  </button>
                </div>
              </>
            </ModalContainer>
          </MyModal>
        )}
      </div>
    </>
  );
}
